import { FC } from "react";

import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { AutomatedCommunicationCard } from ".././components/AutomatedCommunicationCard";
import { SendAutomatedEmailTestButton } from "../components/SendAutomatedEmailTestButton";
import { AutomatedCommunicationsFormData, RowKey } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";

interface ThankYouEmailCardProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultContent: string;
  hasDate: boolean;
  hasLocation: boolean;
  isSweepstakes?: boolean;
}

export const ThankYouEmailCard: FC<ThankYouEmailCardProps> = ({
  openRow,
  onToggleOpen,
  defaultContent,
  hasDate,
  hasLocation,
  isSweepstakes = false,
}) => {
  const { t } = useTranslate();
  const form = useFormContext<AutomatedCommunicationsFormData>();
  return (
    <AutomatedCommunicationCard<AutomatedCommunicationsFormData>
      label={t("dashboard", "ticketing.setThankYouEmail.thankYouEmailLabel")}
      control={form.control}
      errors={form.formState.errors}
      dataEmailType="thank-you-email"
      fields={{ subject: "thankYouWinner.subject", content: "thankYouWinner.content" }}
      enabled
      lockedOn
      toggleTooltip={t(
        "dashboard",
        isSweepstakes ? "sweepstakes.email.alwaysEnabledTooltip" : "ticketing.setThankYouEmail.alwaysEnabledTooltip"
      )}
      chip={{
        label: t(
          "dashboard",
          isSweepstakes
            ? "sweepstakes.email.sentFollowingParticipation"
            : "ticketing.setThankYouEmail.chipLabel.sentFollowingPurchase"
        ),
        tooltip: t(
          "dashboard",
          isSweepstakes
            ? "sweepstakes.email.sentFollowingParticipationTooltip"
            : "ticketing.setThankYouEmail.chipLabel.sentFollowingPurchaseTooltip"
        ),
        showWhen: "enabled",
      }}
      collapse={{ isOpen: openRow === "thank-you-email", onToggle: () => onToggleOpen("thank-you-email") }}
      body={{
        defaultValue: defaultContent,
        attachmentFieldName: "thankYouWinner.attachment",
        customConfig: { date: hasDate, location: hasLocation, eTicket: false },
      }}
      dataTestPrefix="live-form-editor-customization-email"
      footnote={
        <Box marginTop={2} display="flex" justifyContent="flex-start">
          <SendAutomatedEmailTestButton
            emailType="ticketing-thank-you"
            subjectFieldName="thankYouWinner.subject"
            contentFieldName="thankYouWinner.content"
            attachmentFieldName="thankYouWinner.attachment"
          />
        </Box>
      }
    />
  );
};
